module.exports = __webpack_public_path__ + "static/bg-via-mizner-9dc3692638f9fb2ca748e6bbbcd17a92.webp";